/**
 * Client-side copy of the API's FileReportRules (TIXApp.Modules.Reports/Validation). The API
 * enforces them too; checking here just saves uploading 25 MB to be told no.
 */
export const MAX_CAPTION_LENGTH = 100;
export const MAX_FILE_NAME_LENGTH = 100;
export const MAX_ANNOTATION_LENGTH = 1000;
export const MAX_FILE_BYTES = 25 * 1024 * 1024;

export const ALLOWED_EXTENSIONS = [
  '.pdf',
  '.ppt',
  '.pptx',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.xlsm',
];

/** For the file input's `accept` attribute */
export const ACCEPT_ATTRIBUTE = ALLOWED_EXTENSIONS.join(',');

/** The category behind Pool Point Calculation; legacy showed this warning for it (by id 95). */
export const KEY_ENTITLEMENT_CATEGORY = 'Key Entitlement';
export const KEY_ENTITLEMENT_WARNING =
  'Please ensure the Finance Directors review has been completed and documented.';

/** Why the file cannot be uploaded, or null when it is acceptable. */
export function validateFile(file: File | null): string | null {
  if (!file) return 'Choose a file to upload.';
  const dot = file.name.lastIndexOf('.');
  const extension = dot >= 0 ? file.name.slice(dot).toLowerCase() : '';
  if (!ALLOWED_EXTENSIONS.includes(extension)) {
    return `This file type is not allowed. Allowed types: ${ALLOWED_EXTENSIONS.join(', ')}.`;
  }
  if (file.name.length > MAX_FILE_NAME_LENGTH) {
    return `The file name must be at most ${MAX_FILE_NAME_LENGTH} characters. Rename the file and try again.`;
  }
  if (file.size === 0) return 'The file is empty.';
  if (file.size > MAX_FILE_BYTES) {
    return `The file is ${formatMegabytes(file.size)}; the limit is ${formatMegabytes(MAX_FILE_BYTES)}.`;
  }
  return null;
}

export function formatMegabytes(bytes: number): string {
  return `${(bytes / (1024 * 1024)).toFixed(bytes < 1024 * 1024 ? 2 : 1)} MB`;
}

/** Local date as yyyy-MM-dd, the format the API and `<input type="date">` use. */
export function toDateInputValue(date: Date): string {
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
